module.exports = __webpack_public_path__ + "img/panda_octainfo_icon.631aee82.svg";